/**
 * Template: Bulk Order Module
 * -----------------------------------------------------------------------------
 * Load components for bulk order module page template.
 *
 */

import BulkOrderModule from '~/components/bulk-order-module'

document.addEventListener('DOMContentLoaded', () => {
  BulkOrderModule().init()
})
